import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const BasicSanitationChartsDataContext = createContext();

const BasicSanitationChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.BASIC_SANITATION_FAMILIES,   
            url: 'governanceroom/dashboard/unifiedregistry/families/basic-sanitation'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              garbageDestination: data?.garbageDestination ?? [],
              hasBathroom: data?.hasBathroom ?? [],
              hasPipedWater: data?.hasPipedWater ?? [],
              sanitaryDrainage: data?.sanitaryDrainage ?? [],
              waterSupplier: data?.waterSupplier ?? []
          }
        : {
              garbageDestination: [],
              hasBathroom: [],
              hasPipedWater: [],
              sanitaryDrainage: [],
              waterSupplier: []
          };

    return (
        <BasicSanitationChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </BasicSanitationChartsDataContext.Provider>
    );
};

export default BasicSanitationChartsDataProvider;
